



















































































































import Vue from 'vue'
import DetailModal from '@/components/History/DetailModal.vue'
import { tableHeaders } from '@/data-dummy/data-dummy'
import { mapActions, mapGetters } from 'vuex'

export default Vue.extend({
  name: 'check-table',
  components: {
    DetailModal
  },
  data: () => ({
    showFromDate: false,
    showToDate: false,
    timePeriod: ['La semana pasada', 'El mes pasado', 'El año pasado', 'Todo el tiempo', 'Hoy'],
    headers: tableHeaders,
    flags: {
      CO: require('@/assets/icons/flag/colombia.svg'),
      MX: require('@/assets/icons/flag/mexico.svg'),
      CL: require('@/assets/icons/flag/chile.svg'),
      BR: require('@/assets/icons/flag/brazil.svg')
    },
    status: {
      done: 'mdi-checkbox-marked-circle',
      inProgress: 'mdi-clock',
      error: 'mdi-alert-circle'
    },
    filter: {
      time: '',
      from: '',
      to: ''
    },
    loadingTable: false,
    showDetail: false,
    filteredData: []
  }),
  computed: {
    ...mapGetters('history', { tableData: 'getCheckItems', loadInfo: 'getCheckLoadStatus' })
  },
  mounted () {
    setTimeout(() => {
      this.setHistoryResults({ table: 'check', itemsPerLoad: 4 })
    }, 1200)

    this.filteredData = this.tableData

    this.$nextTick(function () {
      window.addEventListener('scroll', this.loadOnScroll)
      this.loadOnScroll() // needed for initial loading on page
    })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.loadOnScroll)
  },
  methods: {
    ...mapActions('history', { setHistoryResults: 'setHistoryResults' }),
    getFlags (country: 'CO' | 'MX' | 'CL' | 'BR') {
      return this.flags[country]
    },
    loadOnScroll () {
      const marginTop = (this.$refs.table as any).getBoundingClientRect().top
      const innerHeight = window.innerHeight

      if (marginTop - innerHeight < -100) {
        if (this.loadInfo) {
          this.loadingTable = true
          setTimeout(() => {
            this.setHistoryResults({ table: 'check', itemsPerLoad: 10 })
            this.loadingTable = false
          }, 2000)
        }
      }
    }
  },
  watch: {
    tableData () {
      this.filteredData = this.tableData
    },
    'filter.from' () {
      this.loadingTable = true
      setTimeout(() => {
        const sliceIndex = Math.floor(Math.random() * this.tableData.length)
        this.filteredData = this.tableData.slice(sliceIndex)
        this.loadingTable = false
      }, 1200)
    },
    'filter.to' () {
      this.loadingTable = true
      setTimeout(() => {
        const sliceIndexStart = Math.floor(Math.random() * this.tableData.length / 3)
        const sliceIndexEnd = Math.floor(Math.random() * this.tableData.length / 3)
        const dataHalf = Math.floor(this.tableData.length / 2)
        this.filteredData = this.tableData.slice(dataHalf - sliceIndexStart, dataHalf + sliceIndexEnd)
        this.loadingTable = false
      }, 1300)
    }
  }
})
